// src/modules/billing/api.js
import API from '../../services/api';
import { headerSafeFileName } from '../../utils/headerSafeFileName';

//Get all Schemes for Drop down
 export const fetchSchemeList = async ({
  search = "",
  page = 1,
  limit = 10,
}) => {
  try {
    const response = await API.get("schemes/list", {
      params: {
        search,
        page,
        limit,
      },
    });
    return response; // Return the response data
  } catch (error) {
    console.error("Error fetching Scheme:", error);
    return error;
  }
};

// Fetch all bills with search and pagination support
export const fetchBills = async ({ search = '', page = 1, limit = 10 }) => {
  try {
    const response = await API.get('/bills/getBills', {
      params: {
        search,
        page,
        limit
      },
    });
    console.log(JSON.stringify(response.data.data));
    return response.data;  // Return the response data
  } catch (error) {
    console.error('Error fetching bills:', error);
    throw error;
  }
};

// Create a new bill
export const createBill = async (billData) => {
  try {
    const response = await API.post('bills/createBill', billData); // Send a POST request to create a bill
    return response.data;  // Return the newly created bill data
  } catch (error) {
    console.error('Error creating bill:', error);
    throw error;
  }
};

// Get a bill by ID
export const fetchBillById = async (billId) => {
  try {
    const response = await API.get(`/bills/${billId}`); // Send GET request to fetch a bill by ID
    return response.data;  // Return the bill data
  } catch (error) {
    console.error('Error fetching bill by ID:', error);
    throw error;
  }
};

// Public bill verification (no auth) — used by the QR-code landing page
export const fetchBillVerification = async (id) => {
  try {
    const response = await API.get(`/bills/verify/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error verifying bill:', error);
    throw error;
  }
};

// Download bill as PDF
export const downloadBillPdf = async (billId, billObjectId) => {
  try {
    // Use MongoDB _id if available, fallback to billId
    const id = billObjectId || billId;
    if (!id) {
      throw new Error('Bill ID not available');
    }
    console.log('[Frontend API] downloadBillPdf - billId:', billId, 'billObjectId:', billObjectId, 'Final ID:', id);
    
    const url = `/bills/${id}/print`;
    console.log('[Frontend API] Requesting URL:', url);
    
    const response = await API.get(url, {
      responseType: 'blob'
    });
    
    console.log('[Frontend API] Response received, type:', response.data.type, 'size:', response.data.size);
    
    // Create blob URL and trigger download
    const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = blobUrl;
    const filename = 'Bill_' + (billId || id) + '.pdf';
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    
    console.log('[Frontend API] Triggering download for:', filename);
    link.click();
    
    // Cleanup
    setTimeout(() => {
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
      console.log('[Frontend API] Cleanup completed');
    }, 100);
  } catch (error) {
    console.error('[Frontend API] Error downloading bill PDF:', {
      message: error.message,
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data,
      fullError: error
    });
    throw new Error(error.response?.data?.message || error.message || 'Unknown error accessing PDF endpoint');
  }
};


// Invoice Download — compact single-page invoice (backend billInvoicePdfService)
export const downloadBillInvoicePdf = async (billId, billObjectId) => {
  const id = billObjectId || billId;
  if (!id) throw new Error('Bill ID not available');
  try {
    const response = await API.get(`/bills/${id}/invoice`, { responseType: 'blob' });
    const blobUrl = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
    const link = document.createElement('a');
    link.href = blobUrl;
    link.setAttribute('download', `Invoice_${billId || id}.pdf`);
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    }, 100);
  } catch (error) {
    // Error bodies arrive as a Blob because of responseType: 'blob'
    let message = error.message;
    const data = error.response?.data;
    if (data instanceof Blob) {
      try { message = JSON.parse(await data.text())?.message || message; } catch { /* keep default */ }
    }
    throw new Error(message || 'Unknown error generating the invoice');
  }
};

export const fetchCustomers = ({ search = '', page = 1, limit = 10 }) =>
  API.get('/customers', {
    params: { search, page, limit },
  }).then((res) => res.data);

  export const updateCustomerAadhaar = ({ search = '', page = 1, limit = 10 }) =>
  API.get('/customers', {
    params: { search, page, limit },
  }).then((res) => res.data);

// Update customer photo
export const updateCustomerPhoto = async (customerId, photoData) => {
  try {
    const response = await API.put(`/customers/${customerId}/photo`, { photo: photoData });
    return response.data;
  } catch (error) {
    console.error('Error updating customer photo:', error);
    throw error;
  }
};

// eSign API functions

// Start eSign request and get signing URL
export const startESign = async (eSignData) => {
  try {
    const response = await API.post('/esign/start', eSignData);
    return response.data;
  } catch (error) {
    console.error('Error starting eSign:', error);
    throw error;
  }
};

// Finalize eSign and create bill
export const finalizeESign = async (requestId, documentId) => {
  try {
    const response = await API.post('/esign/finalize', { requestId, documentId });
    return response.data;
  } catch (error) {
    console.error('Error finalizing eSign:', error);
    throw error;
  }
};

// Our own record of a bill sign request (no Leegality call).
export const getBillSignRecord = async (documentId) => {
  const response = await API.get(`/esign/document/status/${documentId}`);
  return response.data?.data;
};

// Get eSign status
export const getESignStatus = async (documentId) => {
  try {
    const response = await API.get(`/esign/status/${documentId}`);
    return response.data;
  } catch (error) {
    console.error('Error getting eSign status:', error);
    throw error;
  }
};

export const uploadRawImage = async (file, { fileName, folderId } = {}) => {
  console.log('[Frontend] uploadRawImage called with file:', file?.name || 'unnamed', 'size:', file?.size);
  if (!file) {
    throw new Error('File is required for upload');
  }

  const resolvedName = fileName || file.name || `auriksha_upload_${Date.now()}.jpg`;
  const headers = {
    'Content-Type': 'application/octet-stream',
    'x-file-name': headerSafeFileName(resolvedName)
  };

  if (folderId) {
    headers['x-folder-path'] = folderId; // Updated to match ImageKit service
  }

  console.log('[Frontend] Uploading to /uploads/buffer with headers:', headers);
  try {
    const response = await API.post('/uploads/buffer', file, { // Updated to new route
      headers,
      transformRequest: [(data) => data],
      maxBodyLength: Infinity
    });
    console.log('[Frontend] Upload successful:', response.data);
    return response.data;
  } catch (error) {
    console.error('[Frontend] Upload failed:', error);
    throw error;
  }
};